/* eslint import/prefer-default-export: 0 */
import jQuery from 'jquery';

export const appendRating = (data, $ratingSpans, $ratingCells, ratingIds) => {
    if (!data) {
        jQuery.merge($ratingSpans, $ratingCells).text('-');
        return;
    }

    const getRating = idx => data[ratingIds[idx]] || '-';
    $ratingCells.text(getRating);
    $ratingSpans.text(getRating);
};



// WEBPACK FOOTER //
// ./lib/js/modules/myRating/appendRating.js